<template>

  <div  id="sub_wrap">   <!--id="sub_wrap" 대시보드일때 wrap -->
    <header id="header_wrap" class="">
      <!-- 상단 메뉴 -->
      <div class="header_link">
        <div class="grab">

          <div class="link">
            <p>{{user_name}}</p>
            <a class="login en-malgun" v-on:click="goLogin()" title="">{{loginText}}</a>
            <!--<a class="lang en-malgun" v-on:click="toggleLanguage()" title="">{{ $t("lang_str") }}</a>-->
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <main_menu v-on:goPage="goPage" v-on:goHome="goHome"></main_menu>

    </header>
    <!-- header end -->
      <router-view/>
    <!--footer start-->
    <footer class="footer">

      <div class="grab">
        <div class="footer_txt">
          <address class="address">
            (17035)&nbsp;{{ $t("address") }}&nbsp;&nbsp;&nbsp;    &nbsp;
          </address>
          <p>Tel 031-8020-5586 ㅣ Fax 031-8020-5574ㅣ E-mail rokmcjjb717@hufs.ac.kr</p>
          <p class="copyright">Copyright (C) Research Center for Atmospheric Environment . All Rights Reserved.</p>
        </div>

        <div class="mark">
          <img src="/static/img/logo_gray.png" alt="">
        </div>

        <div class="clearfix"></div>
        <button type="button" id="cntTop" style="display: none;">
          <img src="/static/img/top.png" >
        </button>
      </div>
      {{currentLang}}
    </footer>
    <!--footer end-->

  </div>
</template>
<script>
  import comp1 from './Comp1'
  import main_menu from './Menu'
  import {EventBus} from '../js/EventBus'
  import { mapState } from 'vuex'
  import Constant from '../constant'
  import _ from 'lodash'

  export default {
    name: 'Home',
    data: function () {
      return {
        menus : [
          { title : 'research' , subs : [ '연구분야' ,'수행 연구과제','연구성과'] },
          { title : '도시기상환경정보' , subs : [ '관측자료 표출시스템','WISE 홈페이지'] },
          { title : '알림' , subs : [ '센터소식','학술 및 홍보활동'] },
          { title : '센터소식' , subs : [ '센터 설립목적','참여 연구원','장소','CI'] }
          ],
        currentMenu : 0,
        currentSubMenu: 0,
        langText: 'ENGLISH',
        //currentLang : this.$i18n.locale
      }
    },
    /*watch: {
      currentLang : function(lang) {
        this.langText = lang
        console.log('xxx')
      }
    },*/
    components: {
      comp1,
      main_menu
    },

    computed: _.extend({
      showMenu: function ()
      {
        return 0;
      },
      loginText: function()
      {
        console.log('$$ loginText1 : ' + this.login_state)
        if(this.login_state === true)
        {
          console.log('$$ loginText2 : ' + this.login_state)
          return 'LOGOUT'

        }
        return 'LOGIN'
      }

    },mapState(['user_name' , 'login_state'])),

    created : function() {
      EventBus.$on('event-bus-test', this.test)
      EventBus.$on('go-page-index', this.goPageIndex)
      EventBus.$on('go-page-name', this.goPageName)
    },
    methods : {
      test: function(i){
        console.log('xx ' +i)
      },
      goPageIndex: function(menuIndex , subMenuIndex) {
        this.currentMenu = menuIndex;
        this.currentSubMenu = subMenuIndex;

        if(menuIndex == 0) {
          if(subMenuIndex == 0) this.$router.push({name: 'centerpurpose'});
          else if(subMenuIndex == 1) this.$router.push({name: 'centerhistory'});
          else if(subMenuIndex == 2) this.$router.push({name: 'centerperson'});
          else if(subMenuIndex == 3) this.$router.push({name: 'centerlocation'});
          else if(subMenuIndex == 4) this.$router.push({name: 'centerCI'})
        }

        else if( menuIndex == 1 ) {
          if(subMenuIndex == 0) this.$router.push({name: 'researchfield'});
          else if(subMenuIndex == 1) this.$router.push({name: 'researchperform'});
          else if(subMenuIndex == 2) this.$router.push({name: 'researchresult'})
        }
        else if(menuIndex == 2) {
          if(subMenuIndex == 0) this.$router.push({name: 'datasystem'});
          else if(subMenuIndex == 1) this.$router.push({name: 'datawise'})
        }
        else if(menuIndex == 3) {
          if(subMenuIndex == 0) this.$router.push({name: 'noticenews'});
          else if(subMenuIndex == 1) this.$router.push({name: 'noticeactive'})
        }

        console.log('##' + menuIndex + ' ' + subMenuIndex )
      },
      goPageName: function(name , params)
      {
        this.currentMenu = 0;
        this.currentSubMenu = 0;
        this.$router.push({name: name, params:params })


        //EventBus.$emit('event-bus-test', 5);
        //console.log('xx go home')


      },
      goLogin: function()
      {
        this.currentMenu = 0;
        this.currentSubMenu = 0;

        var b = this.login_state

        console.log('## login_state ' + (b==true))
        console.log('## login_state ' + (b==false) )

        if( this.login_state==true )
        {
          //console.log('## login_state1 ' + this.login_state )
          if(confirm("로그아웃 하시겠습니까?"))
          {
            this.$store.dispatch(Constant.LOGOUT)
          }
        }
        else
        {
          console.log('## login_state2 ' + this.login_state )
          this.$router.push({name: 'login'})

        }

        /*
        if(this.login_state == true) {
          this.$router.push({name: 'login'})
        }
        else
        {
          if(confirm("로그아웃 하시겠습니까?"))
          {
            this.$store.dispatch(Constant.LOGOUT)
          }
        }
        */
      },
      toggleLanguage() {
        this.$root.toggleLanguage()
        //this.menus[0].title = this.$t('message.subtitle')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue